document.addEventListener("DOMContentLoaded", function () {
  const scrollOffset = 150;

  // Smooth scroll if there's a hash in the URL
  if (window.location.hash) {
    const hash = window.location.hash;
    history.replaceState(null, null, window.location.pathname + window.location.search);
    window.scrollTo(0, 0);

    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = targetPosition - scrollOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        history.replaceState(null, null, window.location.pathname + window.location.search + hash);
      }
    }, 200);
  }

  // Handle clicks on fabric description anchor links
  document.querySelectorAll('.block_fabric-info-data-description a').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      const target = document.querySelector(targetId);

      if (target) {
        e.preventDefault();
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = targetPosition - scrollOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        history.pushState(null, null, targetId);
      }
    });
  });

  // Handle filtering based on ?letter=A
  const urlParams = new URLSearchParams(window.location.search);
  let selectedLetter = urlParams.get("letter");
  selectedLetter = selectedLetter ? selectedLetter.toLowerCase() : 'a';

  const fabricCards = document.querySelectorAll(".block_fabric-info-data-inner");
  const letterLinks = document.querySelectorAll(".block_fabric-data-words-title");

  fabricCards.forEach(function (card) {
    const cardLetter = card.getAttribute("data-title");
    if (cardLetter === selectedLetter) {
      card.classList.remove("hidden");
    } else {
      card.classList.add("hidden");
    }
  });

  letterLinks.forEach(function (link) {
    const href = link.getAttribute("href");
    const linkLetter = href.includes("letter=") ? href.split("letter=")[1].toLowerCase() : '';
    if (linkLetter === selectedLetter) {
      link.classList.add("active");
    } else {
      link.classList.remove("active");
    }
  });
});
